import API from '@/amplify/api';
import { editCorporationContractDetail } from '@/graphql/mutations'

export const updateCorporationContractDetail = async (APIClient, requestBody) => {
    try {
        const res = await API.graphql({
            query: editCorporationContractDetail,
            variables: { editCorporationContractDetailRequestDto: requestBody }
        });
        return res.data.editCorporationContractDetail;
    } catch (error) {
        console.log('error :>> ', error);
    }
}